import { Navigate } from 'react-router-dom';
import { useAuthContext } from '../../hooks/UseAuthContext';

/**
 * Wraps routes that should only be accessible when logged OUT.
 * - If logged out → renders children (login / signup pages)
 * - If logged in  → redirects to home so users can't see login page
 *   when they're already authenticated
 */
export default function GuestRoute({ children }) {
  const { user } = useAuthContext();

  if (user) {
    return <Navigate to="/" replace />;
  }

  return children;
}